//
// CrosstabElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "../../models/visualElements/crosstab/CrosstabSummary";
import "../../models/visualElements/CrosstabElement";
import "@sas-dvr/ltjs-commons/models/crosstab/Crosstab";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "@sas-dvr/ltjs-commons/rules/interfaces/Rule";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";
import "../../models/visualElements/crosstab/CrosstabMeasure";

var CrosstabElementController = createModule("BIRD::CrosstabElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    {
        ROW_COLUMN_LIMIT_EXCEEDED: 50000,
    },
    ,
    ,
    {
        summary: 1,
    },
    {
        getTotalStyleChain: [1],
        _sort_on: [0,1,4],
        getLevelIntersection: [[7],4,4],
        canSort: [2,1],
        getTableStyleChain: [1],
        getSubtotalStyleChain: [1],
        isAnyMeasureUsingFullFormat: [2],
        _sort_o: [0,1],
        getColumnHeaderStyleChain: [1],
        generateDisplayRule: [1,1,1],
        getViewerModel: [1],
        getRowHeaderStyleChain: [1],
        canCreateHierarchyFromRows: [2],
        isCellSelected: [2,4,4],
        getModel: [1],
        getBrushStyleChain: [1],
        getMeasureVariableLabels: [[7]],
        getRowHierarchyName: [7],
        getSelectedStyleChain: [1],
        getLevelSortDirection: [4,1],
        triggerInteractionsForExcludeAll: [0],
        createHierarchyFromColumns: [0],
        setCurrentSelectedNodePairs: [0,[1]],
        getMeasureFromColumnAxisLeafIndex: [1,4],
        getMeasureHeaderStyleChain: [1],
        canCreateHierarchyFromColumns: [2],
        setCurrentSelectedIndex: [0,4,4],
        getColumnHierarchyName: [7],
        createHierarchyFromRows: [0],
    },
    {
        _create: [4,1],
    },
    ["sort"],
]);
export default CrosstabElementController;
